import { useQuery } from '@apollo/client';
import { GET_LIST } from '../gqlSchemes/getList';
import { useState } from 'react';

export interface CarePlan {
  id: string;
  status: string;
  title: string;
  subtitle: string;
}

export function useGetCarePlansForList({
  perPage,
  filter = { title: '' },
}: {
  perPage: number;
  filter: { title: string; status?: string };
}) {
  const [carePlans, setCarePlans] = useState<CarePlan[]>([]);
  const [page, setPage] = useState(0);
  const { fetchMore, loading } = useQuery(GET_LIST, {
    fetchPolicy: 'no-cache',
    variables: {
      filter,
      page: 0,
      perPage,
    },
    onCompleted: (res) => {
      const items = res.planDefinition?.planDefinitionPagination?.items;
      if (items?.length > 0) {
        setCarePlans(items);
        setPage(1);
      }
    },
  });

  const loadMore = () => {
    fetchMore({
      variables: {
        filter,
        page,
        perPage,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        const items =
          fetchMoreResult.planDefinition?.planDefinitionPagination?.items;
        if (items?.length > 0) {
          setCarePlans((curr) => [...curr, ...items]);
          setPage((prevPage) => prevPage + 1);
        }
      },
    });
  };

  return {
    carePlans,
    loadMore,
    loading,
  };
}
